<!--
    Component: Publication
    Represent a publication of a device.
    Exist four publication types:
        _LinkPublication: A url.
        _MarkdownPublication: A text in markdown format
        _SimplePublication: A short text
        _TextPublication: A long text
-->
<template>
    <v-layout>
        <v-flex>
            <v-card>
                <v-card-title>
                    <div>
                        <h3 class="headline mb-0 blue--text">{{data_internal.title}} <span class="caption black--text" >{{ data_internal.created_at }}</span></h3>
                    </div>
                </v-card-title>

                <!-- Publication Type -->
                <sample-publication     :data="data_internal" :key="data_internal.id" v-if="data_internal.type === 'simple'"></sample-publication>
                <link-publication       :data="data_internal" :key="data_internal.id" v-if="data_internal.type === 'link'"></link-publication>
                <markdown-publication   :data="data_internal" :key="data_internal.id" v-if="data_internal.type === 'markdown'"></markdown-publication>
                <text-publication       :data="data_internal" :key="data_internal.id" v-if="data_internal.type === 'text'"></text-publication>
            </v-card>
        </v-flex>
    </v-layout>
</template>
<script>
    import LinkPublication from "./_LinkPublication"
    import MarkdownPublication from "./_MarkdownPublication"
    import SamplePublication from "./_SimplePublication"
    import TextPublication from "./_TextPublication"

    export default {
        name: 'Publication',
        components: {LinkPublication, MarkdownPublication, SamplePublication, TextPublication},
        props: {
            data: {}
        },
        computed: {
            data_internal(){
                let newDate = new Date(this.data.created_at + ' UTC');
                return {
                    ...this.data,
                    created_at: newDate.toLocaleTimeString() + ' ' + newDate.toLocaleDateString(),
                    payload: JSON.parse(this.data.payload)
                }
            }
        },
    }
</script>
